import EditItem from './EditItem'
import ViewItem from './ViewItem'
import {useState} from 'react'
import AdminEdit from './AdminEdit'


const useNote = () => {
    const [isOpen, setIsOpen] = useState(true)

    const viewSwitcher = (item, fieldIndex, onEditMode, admin, classes, index, formikProps, label) => {
        if (onEditMode) {
            return <EditItem item={item} index={index} fieldIndex={fieldIndex} formikProps={formikProps} />
        } else if (admin) {
            return <AdminEdit label={label} index={index} />
        } else {
            return <ViewItem item={item} />
        }
    }

   return {viewSwitcher, isOpen, setIsOpen}
}

export default useNote